import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import viewImage from "../../assets/images/icons/view.svg";
import TeamImg from '../../assets/images/login-bg.jpg';
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import UploadImg from "../../assets/images/icons/upload-img.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import Pagination from "react-bootstrap/Pagination";
import { Button } from "react-bootstrap";

function AddSubscription() {
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Add Subscription</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">                
                <div className="d-flex align-items-center justufy-content-start col-md-12 px-0">
                  <Button className="rounded-lg">Add</Button>
                  <Button className="rounded-lg ml-4 bg-white">Cancel</Button>
                </div>
              </div>
              <div className="row mx-n2">
                <div className="form-group col-md-4 px-2">
                  <select className="form-control default">
                    <option>Select Subscription ID</option>
                  </select>
                </div>
                <div className="form-group col-md-4 px-2">
                  <input type="text" className="form-control default" placeholder="Enter City Name"/>
                </div>
                <div className="form-group col-md-4 px-2">
                  <input type="text" className="form-control default" placeholder="Enter New Pincode"/>
                </div>
              </div>
              <h5 className="text-white">SUBSCRIPTION INCLUDES</h5>
              <div className="border rounded-14 px-2">
                <ul className="checkList text-white">
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Ai Calls</strong></label>
                    <div>
                      0-50 Calls Per Day. Maximum Of 350 Calls Per Week.<br/>
                      50-100 Calls Per Day. Maximum Of 700 Calls Per Week.<br/>
                      100-200 Calls Per Day. Maximum Of Maximum Of 1,600 Calls Per Week.<br/>
                      200-350 Calls Per Day. Maximum Of 2,450 Calls Per Week.<br/>
                      350+ Calls Per Day. Maximum Of 2,450 Per Week.
                    </div>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Business App</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Online Onboarding</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Driver Assignment</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Ai Calls</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Business App And Driver App</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Driver App</strong></label>
                  </li>
                  <li>
                    <label><div className="checkbox"><input type="checkbox"/></div>
                    <strong>Restaurant Driver Management For External And Freelance Drivers.</strong></label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddSubscription;
